import React from 'react';
import { Redirect } from 'react-router-dom';
import { Pages, Groups } from '../../models';

const LandingPage: React.FC = () => {
  return <Redirect to={Pages[Groups.DEVICES]} />;
};

export default LandingPage;
